import React from 'react';
import LocationChart from './LocationChart';
class LocationChartWrapper extends React.Component {

    render() {
        const {
            locationStats,
        } = this.props;

        return (
            <LocationChart
                chartData={locationStats} />
        );
    }
}

export default LocationChartWrapper;